import axios from 'axios';

const SftGlobalData = {
    // Configuration
    debug: false, // Set to false for production
    baseURL_API: 'https://auth.softtouch.eu/login.php?route=',
    baseURL_API_TEST: 'https://auth2.softtouch.eu/login.php?route=',

    // Encryption key for cookies
    encryptionKey: 'Soft295Touch!',

    // Cookie settings
    cookieName: 'changelog',
    cookieExpireMinutes: 60,

    // Supported languages
    languages: ['nl', 'en', 'fr'],
    defaultLanguage: 'nl',
    version: 'V2.25.49.2',
    post: async function(endpoint, data, options = {}) {
        // Build URL with dev parameter if debug is enabled
        let url = this.debug ? this.baseURL_API_TEST + endpoint : this.baseURL_API + endpoint;
        const urlParams = new URLSearchParams(url.split('?')[1] || '');

        // Add dev parameter if debug is enabled
        if (this.debug && !urlParams.has('dev')) {
            url += (url.includes('?') ? '&' : '?') + 'dev=true';
        }

        // Default headers
        const defaultHeaders = {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        };

        // Merge options
        const config = {
            headers: { ...defaultHeaders, ...(options.headers || {}) },
            validateStatus: function (status) {
                return status < 500;
            },
            ...options
        };

        // Log request info in debug mode
        if (this.debug) {
            console.log('POST Request:', {
                url,
                data,
                config
            });
        }

        try {
            const response = await axios.post(url, data, config);

            // Handle success response (200)
            if (response.status === 200) {
                if (this.debug) {
                    console.log('POST Response Success for ' + endpoint + ':', response);
                    if (response.data?.dev) {
                        console.log('Dev Info:', response.data.dev);
                    }
                }

                const successResponse = {
                    success: true,
                    status: response.status,
                    message: response.data.message || 'Request successful',
                    translation_key: response.data.translation_key,
                    data: response.data.data || null
                };

                if (this.debug && response.data.dev) {
                    successResponse.dev = response.data.dev;
                }

                return successResponse;
            }

            // Handle error response (400)
            if (response.status === 400) {
                if (this.debug) {
                    console.error('POST Error Response (400) for ' + endpoint + ':', response);
                    if (response.data?.dev) {
                        console.error('Dev Info:', response.data.dev);
                    }
                }

                const errorResponse = {
                    success: false,
                    status: response.status,
                    message: response.data.message || 'Bad request',
                    translation_key: response.data.translation_key,
                    error: 'Bad Request'
                };

                if (this.debug && response.data.dev) {
                    errorResponse.dev = response.data.dev;
                }

                return errorResponse;
            }

            // Handle other status codes (401, 403, 404, etc.)
            if (this.debug) {
                console.warn(`Unexpected status code: ${response.status}`, response);
            }

            const otherResponse = {
                success: false,
                status: response.status,
                message: response.data?.message || response.statusText,
                translation_key: response.data?.translation_key,
                error: response.statusText,
                data: response.data
            };

            if (this.debug && response.data?.dev) {
                otherResponse.dev = response.data.dev;
            }

            return otherResponse;

        } catch (error) {
            if (this.debug) {
                console.error('POST Network/Setup Error:', error);
            }

            // Handle 5xx server errors
            if (error.response && error.response.status >= 500) {
                const serverErrorResponse = {
                    success: false,
                    status: error.response.status,
                    message: error.response.data?.message || 'Server error',
                    translation_key: error.response.data?.translation_key || 'error_server',
                    error: error.response.statusText || 'Internal Server Error'
                };

                if (this.debug && error.response.data?.dev) {
                    serverErrorResponse.dev = error.response.data.dev;
                }

                return serverErrorResponse;
            }

            // Handle timeout errors
            if (error.code === 'ECONNABORTED') {
                return {
                    success: false,
                    status: 0,
                    error: 'Request Timeout',
                    message: 'The request took too long to complete',
                    translation_key: 'error_timeout'
                };
            }

            // Handle network errors
            if (error.code === 'ERR_NETWORK') {
                return {
                    success: false,
                    status: 0,
                    error: 'Network Error',
                    message: 'Unable to connect to the server',
                    translation_key: 'error_network'
                };
            }

            // Generic error
            return {
                success: false,
                status: 0,
                error: 'Request Failed',
                message: error.message || 'An unexpected error occurred',
                translation_key: 'error_generic',
                details: error
            };
        }
    }
};

export default SftGlobalData;
